export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-play-video-bc9073a003861c05456eaf1667c36565.svg";